import { reject } from 'lodash-es'

const initialState = {
  isLoading: true,
  handouts: [],
  filesInProgress: new Map(),
}

const updateProgressFiles = (progressFiles, finishedFiles) => {
  finishedFiles.forEach((file) => {
    progressFiles.delete(file.filename)
  })

  return progressFiles
}

export default ({ actionNames }) =>
  (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.FETCH_HANDOUTS_SUCCESS: {
        return {
          ...state,
          handouts: action.data,
          isLoading: false,
          filesInProgress: updateProgressFiles(
            state.filesInProgress,
            action.data
          ),
        }
      }
      case actionNames.UPLOADER_STATE_UPDATE: {
        const [data] = action.payload

        return {
          ...state,
          handouts: data,
        }
      }
      case actionNames.FETCH_HANDOUTS_FAILURE: {
        return {
          ...state,
          isLoading: false,
        }
      }
      case actionNames.REMOVE_HANDOUT: {
        const [filename, mode] = action.payload

        if (mode === 'manage') {
          return state
        }

        return {
          ...state,
          handouts: reject(state.handouts, { filename }),
        }
      }
      case actionNames.UPLOAD_PROGRESS_UPDATED: {
        return {
          ...state,
          filesInProgress: new Map(
            state.filesInProgress.set(action.fileName, {
              percent: action.percent,
              name: action.fileName,
            })
          ),
        }
      }
      default:
        return state
    }
  }
